
<!-- Drag & Drop User Interface for File Upload -->

<div class="sd_dropzone" zsdFileUpload (filesChangeEmiter)="onFilesChange($event)" (click)="selectFile()">
  <div class="sd_dropzone_text" id="sd_dropzone_text">
    <img src="img/icon-upload.png" id="sd_attachment_icon" class="sd_dropzone_icon text-center" width="28" height="28">
    {{ 'FileUpload.dragDrop' | translate }}
  </div>
  
  <input type="file" name="file" id="file" #file class="sd_dropzone_fileupload" 
        multiple="multiple" (change)="onFilesChange(file.files)"/>
</div>
      
<!-- User Interface for Uploaded Files -->

<div *ngFor="let file of fileList; let i = index;trackBy:trackByfile">
  <div class="file_row">
    <span class="file_name" *ngIf="isFilenameSizeWithinLimit(i); else elseBlock">{{ file.name }}</span>
      <ng-template #elseBlock>
        <span class="file_name">{{ file.name.slice(0,52)+' ...' }}</span>       
      </ng-template>
  <div class="cancelfile_btn"><button *ngIf="isFileSizeExceeded(i)" class="btn btn-danger btn-sm" style="margin-right:3px;" type="button"> {{ 'FileUpload.sizeExceeds' | translate }} </button>
    <button class="btn btn-info btn-sm" type="button" (click)="removeFile(i)">&times;</button></div>
  </div>
</div>
  